<script setup>
import {ref, onMounted, provide} from "vue";
import NeedsAIChat from "@/views/needs/chat/NeedsAIChat.vue";
import NeedsList from "@/views/needs/NeedsList.vue";
import NeedsOnboarding from "@/views/needs/NeedsOnboarding.vue";
import needsService from "@/services/needs.service";
import NeedsUpdates from "@/views/needs/NeedsUpdates.vue";

const chat = ref(null);

function startChat() {
    chat.value.open();
}

const needs = ref(null);

onMounted(() => {
    getNeeds();
})

async function getNeeds() {
    const {data} = await needsService.getIndexList();
    needs.value = data;
}

provide('needs', needs)
</script>

<template>
    <div>
        <NeedsOnboarding/>

        <div class="needs-page">
            <template v-if="false">
                <h3 class="heading3 heading3--updates">Updates</h3>
                <NeedsUpdates/>
            </template>

            <h3 v-if="needs?.length" class="heading3 heading3--needs">My Needs</h3>

            <NeedsList/>

            <div class="add-need-wrapper text-center mb-5">
                <a @click="startChat" class="link-add-need">Add New Need</a>
            </div>

            <NeedsAIChat ref="chat"/>
        </div>
    </div>
</template>

<style scoped>
</style>
